export interface MaintenanceRecord {
  id: string;
  bikeId: string;
  date: string;
  type: string;
  description: string;
  cost: number;
  nextDueDate?: string;
  nextDueKm?: number;
  completed: boolean;
  receiptUrl?: string;
}

export type MaintenanceType = 
  | 'tune-up'
  | 'repair'
  | 'part-replacement'
  | 'cleaning'
  | 'inspection'
  | 'other';

export const MAINTENANCE_TYPES: MaintenanceType[] = [
  'tune-up',
  'repair',
  'part-replacement',
  'cleaning',
  'inspection',
  'other'
];

export const MAINTENANCE_TYPE_LABELS: Record<MaintenanceType, string> = {
  'tune-up': 'Tune-up',
  'repair': 'Reparatur',
  'part-replacement': 'Teileersatz',
  'cleaning': 'Reinigung',
  'inspection': 'Inspektion',
  'other': 'Andere'
};
